import React from "react";
import { Card } from "primereact/card";

export default function AuthCard({ heading, extraClassNames, children }) {
  return (
    <Card className="w-25rem">
      {heading ?
      <p className="text-3xl heading font-medium text-center rubik">
        {heading}
      </p>
      : null }
      {children}
    </Card>
  );
}
